import { createFileRoute } from '@tanstack/react-router'
import { MetadataEvalsPage } from 'pages/evaluations/metadata/dashboard/MetadataEvalsPage'

export const Route = createFileRoute('/evaluations/metadata/')({
  component: MetadataEvalsPage,
  staticData: {
    title: 'Metadata Evals',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
      showSearchBar: false,
    },
  },
})
